import { render, staticRenderFns } from "./ScoreComponent.vue?vue&type=template&id=c22ed23e&"
import script from "./ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScoreComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports